import api from '@/services/api';

import ServiceCategoryTypeEnum from '@/constants/common/service_category_type.js';

const UserScenario = {
  verifyUser: () => {
    return api.post('verify_user/', {
      platform_type: ServiceCategoryTypeEnum.LeFILING.value
    });
  }
};

export default UserScenario;
